
// -- React Libraries
import React, { Component } from 'react';
import { connect } from 'react-redux';
import appActions from '../../redux/app/actions';
import { bindActionCreators } from 'redux';
import Sentiment from "sentiment";

// -- Libraries
import axios from 'axios';
import MediaQuery from 'react-responsive';
const { appSelected, searchTermUpdated } = appActions;
import _ from 'lodash';
import writeGood from 'write-good';

// Components
import Header from "../../components/Headers/index";
import HeaderLogo from "../../components/Headers/Logo";
import HeaderMenu from "../../components/Headers/Menu";
import Footer from "../../components/Footer/index";

import AppHeader from "./AppHeader/index";
import AppScore from "./AppScore/index";

import LandingSection from "./ScoreSummary/Landing/index";
import ScoreSummaryTabs from "./ScoreSummary/Tabs/index";
import ScoreSummarySelects from "./ScoreSummary/Selects/index";

// Styles
import "../../Content/Styles/global.css";
import basicStyle from '../../config/basicStyle';
import AsoAnalyticWrapper from './Wrapper';

const dataSet1 = [
  {
      cat: "App Name",
      subCat: 'Format',
      result: 'Remind',
      detail: 'You should use the <span>"Brand Name - Keywords"</span> format. You can rank higher for the keywords in your name.',
      tip1: 'To include relevant keywords in app name.',
      status: '15 character(s)'
  },
  {
    cat: "App Name",
    subCat: 'Branding',
    result: 'Great',
    detail: 'The brand name length is optimal for proper on every device.',
    tip1: 'For optimal presentation on every device.'
  },
  {
    cat: "App Name",
    subCat: 'Length',
    result: 'Great',
    detail: 'You are taking maximum advantage from the title length.',
    tip1: 'The maximum length of an app name is 30-characters long.'
  },
  {
    cat: 'Description',
    subCat: 'Length',
    result: 'Great',
    detail: '90% of top 100 apps use less than 3385 characters for their description in the US app store.',
    tip1: 'Based on the descripitons from the top 100 apps 90% top 100 apps use more than 589 characters, 90% of top 100 apps use less than 3385 characters.',
    tip2: 'Only average 5% of users will click the “more’ button to view the expanded description.',
    tip3: ' Use conise and eye-catching words, and include call-to-action to get the users excited.', 
  },{
    cat: 'Description',
    subCat: 'Spell Check',
    result: 'Great',
    detail: 'There is no spelling mistake in your description'
  },{
    cat: 'Graphics',
    subCat: 'Quantity',
    result: 'Great',
    detail: 'Your made used of 5 screenshots.',
    tip1: 'Showcasee more function and features of the app.'
  },{
    cat: 'Graphics',
    subCat: 'SHAPE',
    result: 'Great',
    detail: 'Keep your screenshots vertical.',
    tip1: 'User can see more screenshots on the narrow screens when the screenshots are vertical.',
    tip2: 'Adding text on your screenshot could help, but make sure they are on a clean background.'
  },{
    cat: 'Graphics',
    subCat: 'PREVIEW VIDEO',
    result: 'Remind',
    detail: 'Your should add a preview video on screenshots.',
    tip1: 'Use the first 5 seconds to grab the viewer’s attention.',
    tip2: 'Focus on the best features, instead of all features.',
    tip3: 'Your video should make sense even with the sound turned off',
    // tip4: ' Inclue a call-to-action.'
  }

];

const _getReviews = async function (appId, country, page, maxPage) {
  if (page <= 0) page = 1;
  if (page > maxPage) return [];

  let response = await axios.post(`https://itunes.apple.com/${country}/rss/customerreviews/page=${page}/id=${appId}/sortBy=mostRecent/json`);

  //ref : https://medium.com/javascript-inside/safely-accessing-deeply-nested-values-in-javascript-99bf72a0855a
  //you could use  https://lodash.com/docs/4.17.4#get or immutable.js
  if (!response) return [];
  if (!response.data) return [];
  if (!response.data.feed) return [];
  if (!response.data.feed.entry) return [];
  if (response.data.feed.entry.length <= 1) return [];

  let entries = response.data.feed.entry;
  let links = response.data.feed.link ? response.data.feed.link : {};
  let reviews = entries
      .filter( (entry, index) => index > 0)
      .filter( (entry) => entry["im:rating"] )
      .filter( (entry) => entry["im:rating"].label );

  links = links.filter( (link) =>
      link.attributes &&
      link.attributes.rel &&
      link.attributes.rel == "last" &&
      link.attributes.href
  );
  if (links.length > 0) {
      var lastLink = links[0].attributes.href.toString();
      var lastPageDescription = new RegExp(/\/page=[0-9]+\//i).exec(lastLink).toString();
      if (lastPageDescription && lastPageDescription.length > 0) {
           let lastPage = parseInt(/[0-9]+/.exec(lastPageDescription).toString());
           if (lastPage < maxPage) maxPage = lastPage;
      }
  }

  return reviews.concat(await _getReviews(appId, country, page + 1, maxPage));
}

class AsoAnalytic extends Component {
  constructor(props) {
    super(props);

    this.state = {
      itunesLookUp: null,
      isLanding: false,
      scores: {
        appName: 0,
        appDescription: 0,
        appGraphics: 0,
        appRatingsAndReviews: 0
      },
      appName: {
        name: '',
        isFormatOk: false,
        isBrandOk: false,
        isLengthOk: false,
        brandLength: 0,
        nameLength: 0
      },
      appDescription: {
        description: '',
        isLengthOk: false,
        isSpellOk: false,
        descriptionLength: 0,
        spellLines: []
      },
      appGraphics: {
        screenshots: [],
        isQuantityOk: false,
        isShapeOk: false,
        isPreviewVideoOk: false
      },
      appRatingsAndReviews: {
        reviews: [],
        isRatingsOk: false,
        isReviewsOk: false,
        averageRating: 0,
        appUserRatingCount: 1,
        sentimentAnalyze: { }
      }
    };

    this.getItunesStoreData = this.getItunesStoreData.bind(this);
  }

  getAnalyzes = function () {
    return {
      appName: this.state.appName,
      appDescription: this.state.appDescription,
      appGraphics: this.state.appGraphics,
      appRatingsAndReviews: this.state.appRatingsAndReviews
    };
  }

  //to be redux saga
  async getItunesStoreData( appId, country ){
    const API_PUBLIC_SEARCH =  'https://itunes.apple.com/lookup';
    
    let results= [];
    try {
      const response = await axios.post(
        API_PUBLIC_SEARCH,{}, { params: { id : appId, country, 'Authorization' : 'Bear xsjsjsjsjkss'} }
      );
      
      console.log( '[getItunesStoreData] ', response.data.results); // error is not defined
      results = response.data.results;
    } catch (error) {
      console.log( '[getItunesStoreData] ', error); // error is not defined
    }

    const itunesLookUp = results[0];

    this.analyzeAppName(itunesLookUp.trackName);
    this.analyzeAppDescription(itunesLookUp.description);
    this.analyzeAppGraphics(itunesLookUp.screenshotUrls);
    this.analyzeRating(itunesLookUp.averageUserRating, itunesLookUp.userRatingCount);

    await this.getReviews(itunesLookUp.trackId, 5);

    results.length > 0 && this.setState({itunesLookUp : itunesLookUp, asoReport: dataSet1});
    console.log(this.state.itunesLookUp);
  }

  getReviews = async function (appId, maxPageOfReviews) {
    let countryCode = this.state.country ? this.state.country.toUpperCase() : "US";
    let reviews = await _getReviews(appId, countryCode, 1, maxPageOfReviews);
    this.analyzeReviews(reviews);
  }.bind(this);

  analyzeAppName = function (appName) {
    let isFormatOk = false;
    let isBrandOk = false;
    let isLengthOk = false;
    let brandLength = 0;
    let nameLength = 0;

    let appNameDivider = appName.indexOf(":");
    if (appNameDivider === -1) appNameDivider = appName.indexOf("-");

    let brandName = appNameDivider !== -1 &&
      appName.substring(0, appNameDivider) ||
      appName;

    let appNameFormatData = _.find(dataSet1, {cat:"App Name", subCat:'Format'});
    let appNameBrandingData = _.find(dataSet1, {cat:"App Name", subCat:'Branding'});
    let appNameLengthData = _.find(dataSet1, {cat:"App Name", subCat:'Length'});

    brandLength = brandName.length;
    nameLength = appName.length;

    isFormatOk = appNameDivider !== -1;
    isBrandOk = brandLength <= 24;
    isLengthOk = nameLength >= 30;

    appNameFormatData.result = isFormatOk && 'Great' || 'Remind';
    appNameBrandingData.result = isBrandOk && 'Great' || 'Remind';
    appNameLengthData.result = isLengthOk && 'Great' || 'Remind';
    
    appNameBrandingData.status = brandLength + ' character(s)';
    appNameLengthData.status = nameLength + ' character(s)';

    dataSet1[0] = appNameFormatData;
    dataSet1[1] = appNameBrandingData;
    dataSet1[2] = appNameLengthData;

    let scores = (isFormatOk ? 1 : 0) +
      (isBrandOk ? 1 : 0) +
      (isLengthOk ? 1 : 0);

    this.setState({
      scores: {
        appName: scores,
        appDescription: this.state.scores.appDescription,
        appGraphics: this.state.scores.appGraphics,
        appRatingsAndReviews: this.state.scores.appRatingsAndReviews
      },
      appName: {
        name: appName,
        isFormatOk: isFormatOk,
        isBrandOk: isBrandOk,
        isLengthOk: isLengthOk,
        brandLength: brandLength,
        nameLength: nameLength
      }
    });
  }

  analyzeAppDescription = function (description) {
    let isLengthOk = false;
    let isSpellOk = false;
    let descriptionLength = 0;
    let spellLines = [];
    
    let descriptionLengthData = _.find(dataSet1, {cat:"Description", subCat:'Length'});
    let descriptionSpellCheckData = _.find(dataSet1, {cat:"Description", subCat:'Spell Check'});

    descriptionLength = description .length;
    spellLines = writeGood(description, { passive: false, adverb: false, weasel: false});

    isLengthOk = descriptionLength > 590 && descriptionLength <= 3385;
    isSpellOk = spellLines.length <= 0;

    descriptionLengthData.result = isLengthOk && 'Great' || 'Remind';
    descriptionSpellCheckData.result = isSpellOk && 'Great' || 'Remind';
    
    descriptionLengthData.status = descriptionLength + ' character(s)';
    descriptionSpellCheckData.suggestions = spellLines;

    dataSet1[3] = descriptionLengthData;
    dataSet1[4] = descriptionSpellCheckData;

    let scores = (isLengthOk ? 1 : 0) +
      (isSpellOk ? 1 : 0);

    this.setState({
      scores: {
        appName: this.state.scores.appName,
        appDescription: scores,
        appGraphics: this.state.scores.appGraphics,
        appRatingsAndReviews: this.state.scores.appRatingsAndReviews
      },
      appDescription: {
        description: description,
        isLengthOk: isLengthOk,
        isSpellOk: isSpellOk,
        descriptionLength: descriptionLength,
        spellLines: spellLines
      }
    });
  }

  analyzeAppGraphics = function (screenshots) {
    let isQuantityOk = false;
    let isShapeOk = true;
    let isPreviewVideoOk = false;

    isQuantityOk = screenshots.length === 5;

    let graphicsQuantityData = _.find(dataSet1, {cat:"Graphics", subCat:'Quantity'});

    graphicsQuantityData.result = isQuantityOk && 'Great' || 'Remind';
    
    dataSet1[5] = graphicsQuantityData;

    let scores = (isQuantityOk ? 1 : 0) +
      (isShapeOk ? 1 : 0) +
      (isPreviewVideoOk ? 1 : 0);

    this.setState({
      scores: {
        appName: this.state.scores.appName,
        appDescription: this.state.scores.appDescription,
        appGraphics: scores,
        appRatingsAndReviews: this.state.scores.appRatingsAndReviews
      },
      appGraphics: {
        screenshots: screenshots,
        isQuantityOk: isQuantityOk,
        isShapeOk: isShapeOk,
        isPreviewVideoOk: isPreviewVideoOk
      }
    });
  }

  analyzeRating = function (appAverageUserRating, appUserRatingCount) {
    let isRatingsOk = appAverageUserRating >= 4;

    let scores = this.state.scores.appRatingsAndReviews +
      (isRatingsOk ? 1 : 0);

    this.setState({
      scores: {
        appName: this.state.scores.appName,
        appDescription: this.state.scores.appDescription,
        appGraphics: this.state.scores.appGraphics,
        appRatingsAndReviews: scores
      },
      appRatingsAndReviews: {
        reviews: this.state.appRatingsAndReviews.reviews,
        isRatingsOk: isRatingsOk,
        isReviewsOk: this.state.appRatingsAndReviews.isReviewsOk,
        averageRating: appAverageUserRating || 0,
        appUserRatingCount: appUserRatingCount || 0,
        sentimentAnalyze: this.state.sentimentAnalyze
      }
    });
  }

  analyzeReviews = function (reviews) {
      let isReviewsOk = false;
      let PositiveScores = [];
      let NegativeScores = [];
      let NeutralScores = [];

      if (reviews.length > 0)
        reviews.map( (review) => {
            let sentimentAnalyze = new Sentiment().analyze(review.content.label);
            var positives = sentimentAnalyze.positive;
            var negatives = sentimentAnalyze.negative;
            if (positives.length > negatives.length) PositiveScores.push(1);
            else if (negatives.length > positives.length) NegativeScores.push(1);
            else NeutralScores.push(1);
        });

      PositiveScores = PositiveScores.length;
      NegativeScores = NegativeScores.length;
      NeutralScores = NeutralScores.length;
      isReviewsOk = PositiveScores > NegativeScores;

      let scores = this.state.scores.appRatingsAndReviews +
        (isReviewsOk ? 1 : 0);
      
      this.setState({
        scores: {
          appName: this.state.scores.appName,
          appDescription: this.state.scores.appDescription,
          appGraphics: this.state.scores.appGraphics,
          appRatingsAndReviews: scores
        },
        appRatingsAndReviews: {
          reviews: reviews,
          isRatingsOk: this.state.appRatingsAndReviews.isRatingsOk,
          isReviewsOk: PositiveScores > NegativeScores,
          averageRating: this.state.appRatingsAndReviews.averageRating,
          appUserRatingCount: this.state.appRatingsAndReviews.appUserRatingCount,
          sentimentAnalyze: {
            positive: PositiveScores,
            negative: NegativeScores,
            neutral: NeutralScores
          }
        }
      });
  }.bind(this);
  
  componentWillReceiveProps() {
    console.log( ' componentWillReceiveProps');
  }

  componentDidUpdate(prevProps, prevState) {
    console.log( ' componentDidUpdate');
  }

  componentDidMount() {
    const { match: { params } } = this.props;

    console.log(params.appId);
    this.getItunesStoreData(params.appId, null);
  }

  render() {
    return (
      <AsoAnalyticWrapper className="page-wrapper">
        <Header>
          <div className="header-row">
            <HeaderLogo isClickable={true} history={this.props.history} />
            <HeaderMenu history={this.props.history} auth={this.props.auth}/>
          </div>
        </Header>
        
        <div>
          <div className="content-wrapper">
            { !this.state.itunesLookUp && (<div className="loading-overlay"><span>载入中</span></div>) }
            <div className="app-summaries">
              {
                this.state.itunesLookUp != null && (
                  <AppHeader
                    imgUrl={this.state.itunesLookUp.artworkUrl100}
                    appName={this.state.itunesLookUp.trackName}
                    publisher={this.state.itunesLookUp.sellerName}
                    currency={this.state.itunesLookUp.currency}
                    price={this.state.itunesLookUp.price}
                    category={this.state.itunesLookUp.genres}
                    version={this.state.itunesLookUp.version}
                    releaseDate={this.state.itunesLookUp.releaseDate}
                    lastUpdated={this.state.itunesLookUp.currentVersionReleaseDate}
                  />
                )
              }
              {
                this.state.asoReport && (
                  <AppScore
                    score={this.state.score}
                    scores={this.state.scores}
                    maxScore={this.maxScore}
                    countryCode={this.props.countryCode}
                    report={dataSet1}/>
                )
              }
            </div>

            {
              this.state.isLanding && <LandingSection onClick={ ()=>{ this.setState({ isLanding: false }); } }/> || (
                this.state.itunesLookUp && (
                  <div>
                    <MediaQuery minWidth={768}>
                      <ScoreSummaryTabs
                        app={this.state.itunesLookUp}
                        data={this.state.asoReport}
                        country={this.state.country ? this.state.country.toUpperCase() : "US"}
                        analyzes={this.getAnalyzes()}
                      />
                    </MediaQuery>

                    <MediaQuery maxWidth={767}>
                      <ScoreSummarySelects
                        app={this.state.itunesLookUp}
                        data={this.state.asoReport}
                        country={this.state.country ? this.state.country.toUpperCase() : "US"}
                        analyzes={this.getAnalyzes()}
                      />
                    </MediaQuery>
                  </div>
                )
              )
            }
          </div>
        </div>

        <div>
          <div className="consultant-request-wrapper">
            <div className="consultant-request" onClick={ () => document.location = "https://gogochart.cn/Contact-Us.html" }>
              即时获得免费咨询！
            </div>
          </div>
        </div>

        <Footer/>
      </AsoAnalyticWrapper>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return { 
    setApp: (app) => dispatch(appSelected(app)),
    appSelected: bindActionCreators(appSelected, dispatch),
    searchTermUpdated:  bindActionCreators(searchTermUpdated, dispatch),
  }
}
function mapStateToProps(state) {
  const campaign = state.get('deep').campaign;
  return { 
    search: state.get('search'),
    campaign: campaign,
    currentApp: state.getIn( ['App', 'currentApp']),
    secondApp: state.getIn( ['App', 'secondApp']),
    searchTerm: state.getIn( ['App', 'searchTerm']),
    countryCode: state.getIn( ['ItunesSearch', 'countryCode']) && 'US',
  }
}

export default  connect(
  mapStateToProps,
  mapDispatchToProps
)(AsoAnalytic);



// WEBPACK FOOTER //
// ./src/containers/AsoAnalytic/index.js